export const JockeyIndexMockData = [
    {
        index: "1",
        name: "L Hewitson",
        runs: "675",
        wins: "84",
        winperc: "12.44",
        winplaceperc: "58.81",
        stakes: "R 7,651,487.50"
    },
    {
        index: "2",
        name: "A Marcus",
        runs: "255",
        wins: "80",
        winperc: "31.37",
        winplaceperc: "74.51",
        stakes: "R 7,907,287.50"
    },
    {
        index: "3",
        name: "R Munger",
        runs: "579",
        wins: "69",
        winperc: "11.92",
        winplaceperc: "54.06",
        stakes: "R 6,108,250.00"
    },
    {
        index: "4",
        name: "R Fourie",
        runs: "248",
        wins: "62",
        winperc: "25.00",
        winplaceperc: "78.63",
        stakes: "R 5,126,425.00"
    },
    {
        index: "5",
        name: "G Cheyne",
        runs: "333",
        wins: "60",
        winperc: "18.02",
        winplaceperc: "67.87",
        stakes: "R 4,165,250.00"
    },
    {
        index: "6",
        name: "M Yeni",
        runs: "340",
        wins: "55",
        winperc: "16.18",
        winplaceperc: "67.35",
        stakes: "R 6,923,312.50"
    },
    {
        index: "7",
        name: "W Kennedy",
        runs: "450",
        wins: "50",
        winperc: "11.11",
        winplaceperc: "61.33",
        stakes: "R 5,832,175.00"
    },
    {
        index: "8",
        name: "G Lerena",
        runs: "184",
        wins: "50",
        winperc: "27.17",
        winplaceperc: "77.17",
        stakes: "R 4,922,300.00"
    },
    {
        index: "9",
        name: "L J Ferraris",
        runs: "344",
        wins: "37",
        winperc: "10.76",
        winplaceperc: "48.84",
        stakes: "R 3,567,837.50"
    },
    {
        index: "10",
        name: "A Domeyer",
        runs: "197",
        wins: "34",
        winperc: "17.26",
        winplaceperc: "71.07",
        stakes: "R 3,460,150.00"
    },
    {
        index: "11",
        name: "M V.Rensburg",
        runs: "193",
        wins: "27",
        winperc: "13.99",
        winplaceperc: "58.03",
        stakes: "R 2,656,100.00"
    },
    {
        index: "12",
        name: "N Klink",
        runs: "418",
        wins: "34",
        winperc: "8.13",
        winplaceperc: "45.69",
        stakes: "R 2,645,100.00"
    },
    {
        index: "13",
        name: "R Danielson",
        runs: "301",
        wins: "26",
        winperc: "8.64",
        winplaceperc: "47.84",
        stakes: "R 2,622,925.00"
    },
    {
        index: "14",
        name: "N Patel",
        runs: "160",
        wins: "25",
        winperc: "15.63",
        winplaceperc: "59.38",
        stakes: "R 2,346,750.00"
    },
    {
        index: "15",
        name: "D R Lerena",
        runs: "214",
        wins: "20",
        winperc: "9.35",
        winplaceperc: "56.54",
        stakes: "R 2,295,475.00"
    },
    {
        index: "16",
        name: "K Matsunyane",
        runs: "132",
        wins: "17",
        winperc: "12.88",
        winplaceperc: "64.39",
        stakes: "R 2,200,550.00"
    },
    {
        index: "17",
        name: "C Storey",
        runs: "199",
        wins: "23",
        winperc: "11.56",
        winplaceperc: "53.27",
        stakes: "R 2,183,775.00"
    },
    {
        index: "18",
        name: "D De Gouveia",
        runs: "153",
        wins: "19",
        winperc: "12.42",
        winplaceperc: "65.36",
        stakes: "R 2,105,175.00"
    },
    {
        index: "19",
        name: "C Habib",
        runs: "146",
        wins: "13",
        winperc: "8.90",
        winplaceperc: "45.89",
        stakes: "R 2,050,000.00"
    },
    {
        index: "20",
        name: "S Fortune",
        runs: "194",
        wins: "23",
        winperc: "11.86",
        winplaceperc: "56.70",
        stakes: "R 1,843,200.00"
    }
];